export default __webpack_public_path__ + "static/media/remote-meeting-icon-blue.58e5164f.png";